/**
 * Symbol dimensions keep aspect ratio locked unless the user explicitly unlocks them.
 */
export function isSymbolAspectRatioLocked(
  lockAspectRatio?: boolean,
): boolean {
  return lockAspectRatio !== false;
}
